import { ToastService } from './../../services/toast-service';
import { HttpService } from '../../services/http-service';
import { autoinject } from 'aurelia-framework';
import { Paths } from '../../paths';
import { ISchoolSettingsDto } from "typings/project";

@autoinject
export class SchoolSettingsAdmin {
    schoolSettings: Array<ISchoolSettingsDto> =[];
    canSave: boolean;
    newSchoolModal: any;
    constructor(
        private readonly httpService: HttpService,
        private readonly toast: ToastService,
    ){
    }

    openNewSchoolModal(schoolSettings: Array<ISchoolSettingsDto>){
        this.newSchoolModal.open(schoolSettings);
    }

    saveNewSchool(school: ISchoolSettingsDto){
        this.schoolSettings.unshift(school);
    }

    async attached(){
        this.schoolSettings = await this.httpService.get<ISchoolSettingsDto[]>(
            Paths.getAllSchoolsForAdminPath
        );
    }

    async saveChanges(){
        const invalidRows = this.schoolSettings.filter(f => f.display == true && (!f.displayInternal && !f.displayExternal)).length;
        if(invalidRows > 0){
            this.toast.error("Please select internal or external for any displayed schools.")
        }else{
            try{
                await this.httpService.post(Paths.UpdateSchoolsForAdmin, this.schoolSettings);
                this.toast.success("School settings updated.")
            }catch(err){
                this.toast.error("Failed to save settings.")
            }
            
        }
    }

}

